import React from "react";
import { Helmet } from "react-helmet-async";
import { Card } from "react-bootstrap";

import ChangePassword from "../../components/auth/ChangePassword";

const ChangePasswordPage = () => (
  <React.Fragment>
    <Helmet title="Reset Password" />
    <div className="text-center mt-4">
      <h1 className="h2">Reset password</h1>
    </div>

    <Card>
      <Card.Body>
        <div className="m-sm-4">
          <ChangePassword />
        </div>
      </Card.Body>
    </Card>
  </React.Fragment>
);

export default ChangePasswordPage;
